import { IBienLaiThuCreateRequest } from "./../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { call, put, takeLatest } from "redux-saga/effects";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { IMucThuKhacSinhVienSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eThuPhiTheoLopActionIds } from "../../action-types/thu-phi/IThuPhiTheoLopActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IThuPhiTheoLopActionTypes } from "./../../action-types/thu-phi/IThuPhiTheoLopActionTypes";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuKhacSinhVienTheoLopSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienTheoLopSelectRequest";
import { IBienLaiThuTheoLopCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuTheoLopCreateRequest";

export function* thuPhiTheoLopSaga(): any {
  yield takeLatest(eThuPhiTheoLopActionIds.LOAD_MUC_THU_KHAC_START, loadWorker);

  yield takeLatest(
    eThuPhiTheoLopActionIds.CREATE_BIENLAITHU_START,
    createBienLaiWorker
  );
}

function* loadWorker(action: IThuPhiTheoLopActionTypes): any {
  const request = action.payload as IMucThuKhacSinhVienTheoLopSelectRequest;
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectByLopThuChi,
    request
  );
  if (res.is_success) {
    const data: IMucThuKhacSinhVienViewModel[] = res.data;
    yield put(
      rootActions.thuPhi.thuPhiTheoLop.LOAD_MUC_THU_KHAC_SUCCESS({
        request: request,
        data,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiTheoLop.LOAD_MUC_THU_KHAC_ERROR({
        request: request,
        data: res.message ?? "Có lỗi",
      })
    );
  }
}

function* createBienLaiWorker(action: IThuPhiTheoLopActionTypes): any {
  const request = action.payload as IBienLaiThuTheoLopCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.CreateByLop, request);
  if (res.is_success) {
    const data: number = res.data;
    yield put(
      rootActions.thuPhi.thuPhiTheoLop.CREATE_BIENLAITHU_SUCCESS({
        request: {
          hoc_ky: request.hoc_ky,
          nam_hoc: request.nam_hoc,
          id_lop: request.id_lop,
          id_thu_chi: request.id_thu_chi,
        },
        data,
      })
    );
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.LOAD_START({
        hoc_ky: request.hoc_ky,
        nam_hoc: request.nam_hoc,
        id_lop: request.id_lop,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiTheoLop.CREATE_BIENLAITHU_ERROR({
        request: {
          hoc_ky: request.hoc_ky,
          nam_hoc: request.nam_hoc,
          id_lop: request.id_lop,
          id_thu_chi: request.id_thu_chi,
        },
        data: res.message ?? "Có lỗi",
      })
    );
  }
}
